// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import PEPSearchPage from '../../components/PEP/Search';
import { PepSubscription } from '../../types/PepTypes';

interface IProps {
    isAuthenticated: boolean,
    subscriptions: PepSubscription[]
}

const Search: React.FC<IProps> = ({isAuthenticated, subscriptions}) => {
    return (
        <Entrypoint>
            <PEPSearchPage isAuthenticated={isAuthenticated} subscriptions={subscriptions}/>
        </Entrypoint>
    );
}

export default Search;